import {PrixBlockUnitaire} from '@/domains/cadencier/components/PrixBlockUnitaire';
import {AjouterAvecPrixSaisi} from '@/hooks/panier/useAjouterAvecPrixSaisi';
import {State} from '@synako/halitrek';
import {ItemCatalogue2Desc, LigneDePanierDesc} from 'api-types/ffconnect-hal';
import {EditionPrixState} from '@/hooks/panier/usePriceEditor';

export const ProduitPrixBlock: React.FC<{
  item: State<ItemCatalogue2Desc>;
  fontSizeMain?: string;
  fontSizeSecondary?: string;
  // Si fourni, active l'édition du prix (mode commercial avec permission `changer-le-prix`).
  ligneDePanier?: State<LigneDePanierDesc>;
  /** Transmis par la carte catalogue : le tag reste à côté du prix, pas dans le bloc. */
  saisieAvantAjout?: boolean;
  ajouterAvecPrixSaisi?: AjouterAvecPrixSaisi;
  codeArticle?: string;
  /** Remonte le draft au parent pour le preview des marges. */
  onEditionPrixChange?: (state: EditionPrixState) => void;
  /** Prix affiché en promo. N'affiche pas de tag : la carte s'en charge. */
  estPromo?: boolean;
}> = ({
  item,
  fontSizeMain,
  fontSizeSecondary,
  ligneDePanier,
  saisieAvantAjout,
  ajouterAvecPrixSaisi,
  codeArticle,
  onEditionPrixChange,
  estPromo,
}) => {
  const {prix_unitaire_ht, prix_unitaire_ttc, unite_de_facturation, tva} =
    item.data;
  if (!prix_unitaire_ht) return null;

  return (
    <PrixBlockUnitaire
      prixUnitaire={prix_unitaire_ht}
      prixUnitaireTtc={prix_unitaire_ttc}
      uniteFacturation={unite_de_facturation}
      tauxTVA={tva}
      style={{mb: -1, mt: 0, minW: 0}}
      fontSizeMain={fontSizeMain}
      fontSizeSecondary={fontSizeSecondary}
      ligneDePanier={ligneDePanier}
      saisieAvantAjout={saisieAvantAjout}
      ajouterAvecPrixSaisi={ajouterAvecPrixSaisi}
      codeArticle={codeArticle}
      onEditionPrixChange={onEditionPrixChange}
      estPromo={estPromo}
    />
  );
};
